import { useEffect, useState } from "react";
import ButtonElement from "../../Common/ButtonElement";
import TableComponent from "../components/TableComponent";
import SearchBox from "../components/SearchComponent";
import DateRangeSelector from "../../Common/DateRangeElement";
import { DELETE_POP_UP, formatDate, handleDownload, isValidObject, reverseDateFormat } from "../../utils";
import { getInvoices } from "../../actions/vehicles";
import { appApis, dropdownDefaultList, eSign, headerColumn, isInovize } from "../../constants";
import AddPayment from "./components/AddPayment";
import SearchableDropdown from "../../Common/SearchDropdown";
import { shallowEqual, useSelector } from "react-redux";
import Reminder from "./components/Reminder";
import PaymentDetails from "./components/PaymentDetails";
import { RiDeleteBin5Line } from "react-icons/ri";
import { MdOutlineCurrencyRupee, MdOutlineFileDownload } from "react-icons/md";
import { useApiRequest } from "../../hooks/useApiRequest";
import { IoNotificationsOutline } from "react-icons/io5";
import { BsReceipt } from "react-icons/bs";
import InvoiceModal from "../Renewals/components/InvoiceModal";
import { GiTakeMyMoney } from "react-icons/gi";

const Payment = () => {
    const [state, setState] = useState({
        billings: [],
        addbilling: false,
        showInvoiceModal: false,
        showReminder: false,
        loading: false,
        billingData: {},
        search: "",
        company: "",
        status: "",
        current: 1,
        total: 1,
        showDetails: false,
    });

    const { companies, filters } = useSelector(({ companies, inventory }) => ({
        companies: companies?.companies ?? [],
        filters: inventory.filters ?? {}
    }), shallowEqual);
    const { request, loading: deleteRequest } = useApiRequest();


    const { addbilling, billings, billingData, loading, current, total, search, status, company, companyId, showReminder, showDetails, showInvoiceModal } = state;

    const getBillings = (date, pageIndex = null) => {
        let query = `?page=${pageIndex ? pageIndex : current}&limit=200`;
        if (search) query = `${query}&keyword=${search}`;
        if (date?.startDate && date?.endDate) query = `${query}&start_date=${reverseDateFormat(date?.startDate ?? "")}&end_date=${reverseDateFormat(date?.endDate ?? "")}`;
        if (company) query = `${query}&companyId=${companyId}`;
        if (status) query = `${query}&status=${status}`;

        setState(prev => ({ ...prev, loading: true }));
        getInvoices(query).then(response => {
            const { data, meta } = response.data;
            if (isValidObject(data)) {
                setState(prev => ({ ...prev, billings: data?.invoiceList ?? [], total: meta?.total ?? 1 }));
            }
        }).catch(ex => { }).finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    const paginationAction = (pageIndex) => {
        setState(prev => ({ ...prev, current: pageIndex }));
        getBillings(null, pageIndex)
    }

    const deleteAction = (item) => {
        DELETE_POP_UP(() => {
            request({
                url: `${appApis.deleteInvoice}/${item?.invoiceid}`,
                method: "DELETE",
                onSuccess: () => paginationAction(1)
            })
        });
    }

    const downloadInvoice = (item, type) => {
        if (item?.vehiclelist?.length) {
            const defaultValue = item?.vehiclelist?.[0] || {};
            const fromCompany = filters?.billingCompanies?.find(billComp => billComp?.id == defaultValue?.billing_company_id);
            const toCompany = companies?.find(comp => comp?.name == item?.companyname);
            const stamp = isInovize ? fromCompany?.companyStampUrl : eSign[String(fromCompany?.name ?? "").replaceAll(" ", "").toLowerCase() || "sbtracking"];
            const invoiceDetails = {
                fromCompany: {
                    name: fromCompany?.name ?? "",
                    address: fromCompany?.address ?? "",
                    gst: fromCompany?.gstNumber ?? "",
                    email: fromCompany?.email ?? "",
                    phoneNo: fromCompany?.mobileNo ?? "",
                    bankName: fromCompany?.bankName ?? "",
                    branch: fromCompany?.branchName ?? "",
                    accountNo: fromCompany?.bankAccountNo ?? "",
                    ifscCode: fromCompany?.ifscCode ?? "",
                    sacCode: isInovize ? fromCompany?.sacCode ?? "" : "998313",
                    hsnCode: isInovize ? fromCompany?.hsnCode ?? "" : "852691",
                    stampUrl: stamp,
                    digitalSignatureUrl: isInovize ? fromCompany?.digitalSignatureUrl ?? "" : null
                },
                toCompany: {
                    name: toCompany?.name ?? "",
                    address: toCompany?.address ?? "",
                    gst: toCompany?.gstNumber ?? "",
                    email: toCompany?.email ?? "",
                    phoneNo: toCompany?.mobileNo ?? ""
                },
                invoiceNo: item?.invoicenumber ?? "",
                date: formatDate(item?.invoicedate ?? ""),
                vehicles: item?.vehiclelist || [],
                amount: parseInt(item?.billingamount ?? 0),
                gstAmount: parseInt(item?.gstamount ?? 0),
                isComboCase: ((defaultValue?.billing_cycle ?? "") == "Monthly" && (defaultValue?.billing_type ?? "") == "Rented"),
                gstPercentage: (defaultValue?.gst_percentage ?? 0)
            }
            if(type == 1) handleDownload(invoiceDetails, false);
            else setState(prev => ({...prev, showInvoiceModal: true, billingData: {...invoiceDetails, type: 2 }}))
        }
    }

    useEffect(() => {
        paginationAction(1);
    }, [search, company, status])

    return <div className="installer-container">
        <SearchBox placeholder="Search here..." className="mb-3" value={search} onChange={(e) => setState(prev => ({ ...prev, search: e.target.value }))} />
        <TableComponent col={4} breakPoint="lg" title={"Invoice History"} headers={headerColumn.payment} data={billings} current={current} total={total} tableLoading={loading} paginationAction={paginationAction} render={(tdData, index) => <tr key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.invoicedate ?? "-"}</td>
            <td>{tdData?.companyname ?? "-"}</td>
            <td>{tdData?.invoicenumber ?? "-"}</td>
            <td>{parseInt(tdData?.totalamount ?? "") || 0}</td>
            <td>{parseInt(tdData?.amountpaid ?? "") || 0}</td>
            <td>{tdData?.paymentmode ?? "-"}</td>
            <td className="status">
                <span style={{
                    background: tdData?.status == "Paid" ? "green" : tdData?.status == "Partial" ? "orange" : "red",
                }}>{tdData?.status}</span>
            </td>
            <td>{parseInt(tdData?.remainingamount ?? "") || 0}</td>
            <td>
                <div className="d-flex justify-content-center align-items-center">
                    <ButtonElement text={<GiTakeMyMoney size={20} />} cssClass={`more-radius mx-1 small-btn opacity-75`} onClick={(e) => {
                        e.stopPropagation();
                        setState(prev => ({ ...prev, showDetails: true, billingData: tdData }))
                    }} variant="btn-success" loading={false} />
                    <ButtonElement disabled={tdData?.status == "Paid"} text={<MdOutlineCurrencyRupee size={20} />} cssClass="more-radius mx-1 small-btn" onClick={(e) => {
                        e.stopPropagation();
                        setState(prev => ({ ...prev, addbilling: true, billingData: tdData }))
                    }} variant="btn-outline-sucess" loading={false} />
                    <ButtonElement text={<MdOutlineFileDownload size={20} />} cssClass="more-radius mx-1 small-btn" onClick={(e) => {
                        e.stopPropagation();
                        downloadInvoice(tdData, 1);
                    }} variant="btn-outline-grey" loading={false} />
                    <ButtonElement text={<BsReceipt size={20} />} cssClass={`more-radius mx-1 small-btn opacity-${tdData?.vehiclelist?.length >= 10 ? "100" : "50"}`} onClick={(e) => {
                        e.stopPropagation();
                        if(tdData?.vehiclelist?.length >= 10) {
                            downloadInvoice(tdData, 2);
                        }
                    }} variant="btn-outline-blue" loading={false} />
                    <ButtonElement disabled={tdData?.status == "Paid"} text={<IoNotificationsOutline size={20} />} cssClass="more-radius mx-1 small-btn" onClick={(e) => {
                        e.stopPropagation();
                        setState(prev => ({ ...prev, showReminder: true, billingData: tdData }))
                    }} variant="btn-outline-blue" loading={false} />
                    <ButtonElement text={<RiDeleteBin5Line size={20} />} cssClass="more-radius mx-1 small-btn" onClick={(e) => {
                        e.stopPropagation();
                        deleteAction(tdData)
                    }} variant="btn-delete-icon" loading={deleteRequest} />
                </div>
            </td>
        </tr>} FilterComponent={<div className="installer-filters d-flex justify-content-end">
            <SearchableDropdown
                placeholder={"Status"}
                value={status}
                error={false}
                options={dropdownDefaultList.paymentStatus}
                onSelect={(value) => setState(prev => ({ ...prev, status: value?.name ?? "" }))}
            />
            <SearchableDropdown
                placeholder={"Company Name"}
                value={company}
                error={false}
                options={companies}
                onSelect={(value) => setState(prev => ({ ...prev, company: value?.name ?? "", companyId: value?.id ?? null }))}
            />
            <DateRangeSelector updateRange={getBillings} />
        </div>} />

        {addbilling ? <AddPayment show={addbilling} hideModal={() => setState(prev => ({ ...prev, addbilling: false, billingData: {} }))} extraDetails={billingData} getInstData={() => getBillings(1)} /> : null}
        {showReminder ? <Reminder show={showReminder} hideModal={() => setState(prev => ({ ...prev, showReminder: false, billingData: {} }))} extraDetails={billingData} /> : null}
        {showInvoiceModal ? <InvoiceModal show={showInvoiceModal} hideModal={() => setState(prev => ({ ...prev, showInvoiceModal: false, billingData: {} }))} extraDetails={billingData} /> : null}
        {showDetails ? <PaymentDetails show={showDetails} hideModal={() => setState(prev => ({ ...prev, showDetails: false, billingData: {} }))} query={`invoiceId=${billingData?.invoiceid}`} /> : null}
    </div>
}

export default Payment;